import { render, staticRenderFns } from "./ReasonsStep.vue?vue&type=template&id=80e5104e&scoped=true"
import script from "./ReasonsStep.vue?vue&type=script&lang=js"
export * from "./ReasonsStep.vue?vue&type=script&lang=js"
import style0 from "./ReasonsStep.vue?vue&type=style&index=0&id=80e5104e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e5104e",
  null
  
)

export default component.exports